/* eslint-disable id-match, filenames/match-regex */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { FORM_404 } from '../../brands/default/content/components/errors';
import { LINK_HOME } from '../../brands/default/links';
import { trackError } from '../../helpers/analytics';
import ErrorTrackingService from '../../helpers/errorTrackingService';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import { sendErrorDataToSplunk } from '../_generic/axiosSplunk/axiosSplunk';
import ButtonForm from '../_generic/button/CTAButton';

const Form404 = ({ statusCode }) => {
  const router = useRouter();
  const theme = useContext(ThemeContext);

  const goToDeals = () => redirectToURL(LINK_HOME, router);

  useEffect(() => {
    const pageName = 'error pages: 404';
    trackError({
      eVar1: 'error pages',
      eVar2: pageName,
      pageName,
      prop1: 'error pages',
      prop2: pageName,
    });
    sendErrorDataToSplunk(router);
    ErrorTrackingService.logError({
      message: 'User was redirected to a 404 page.',
      name: 'UNHANDLED 404 PAGE',
      path: `${LINK_HOME}${router.asPath}`,
    });
  }, [router]);

  return (
    <div className="not-found">
      <div className="not-found__content">
        <h2 className="not-found__title">
          {FORM_404.notFoundSeriously.replace('##STATUSCODE##', statusCode)}
        </h2>
        <div className="not-found__message">{FORM_404.looksLike}</div>
        <div className="not-found__continue">
          <ButtonForm
            disabled={false}
            gradientButton
            onClick={() => goToDeals()}
            primaryAction
          >
            {FORM_404.continueShopping}
          </ButtonForm>
        </div>
      </div>
      <style global jsx>{`
        .not-found__content {
          margin: 0 auto;
          width: 100%;
          color: #fff;
          padding: 50px 80px 0 40px;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          // 768
          .not-found__content {
            max-width: 768px;
          }
          .not-found {
            background-position: center 0;
          }
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          // 992
          .not-found__content {
            max-width: 992px;
          }
        }
        @media (min-width: ${theme.breakpoints.xlUp}) {
          // 1200
          .not-found__content {
            max-width: 1200px;
          }
        }
        .not-found__title {
          margin: 0;
          max-width: 365px;
          color: #fff;
          font-weight: 400;
          font-size: 44px;
          font-size: 4.4rem;
          line-height: 50px;
          line-height: 5rem;
        }
        .not-found__message {
          color: #fff;
          max-width: 375px;
          margin-bottom: 20px;
          font-size: 30px;
          font-size: 3rem;
          line-height: 35px;
          line-height: 3.5rem;
        }
        .not-found {
          height: 410px;
          background-image: url(${theme.images.error404});
          background-repeat: no-repeat;
          background-color: #383838;
        }

        @media (max-width: ${theme.breakpoints.mdUp}) {
          .not-found__title {
            font-size: 30px;
            font-size: 3rem;
            line-height: 35px;
            line-height: 3.5rem;
            max-width: 300px;
          }
          .not-found__message {
            font-size: 18px;
            font-size: 1.8rem;
            line-height: 24px;
            line-height: 2.4rem;
            max-width: 300px;
          }
          .not-found__content {
            padding: 50px 15px 0;
          }
        }
      `}</style>
    </div>
  );
};

Form404.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Form404.defaultProps = {
  statusCode: '404',
};

export default Form404;
